import { useEffect, useState } from "react";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { Contact } from "../../models/conversations";
import { ColDef, ColumnApi, GridApi, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useDispatch } from "react-redux";
import { LoadUnSubcribedContacts } from "../../actions";
import GridComponent from "../shared/grid";
import { UtilityService } from "../../services/UtilityService";
import { dateComparator } from "../shared/grid/grid.services";
import PageHeaderComponent from "../shared/page-header.component";
import { setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { pageTitles } from "../shared/constants";

const OptOutPolicy: React.FC = () => {
    const dispatch = useDispatch()

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const GetUnSubscribedContacts: Contact[] = useSelector(selector.getUnSubscribedContacts)
    const [gridApi, SetGridApi] = useState<GridApi>(null)
    const [columnApi, SetColumnApi] = useState<ColumnApi>(null)

    const UnsubscribedColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.Name ? params.data.Name : '--'
            },
            hide: !IsMobileDevice
        },
        {
            field: "FirstName",
            headerName: "First Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.FirstName ? params.data.FirstName : '--'
            },
            hide: IsMobileDevice
        },
        {
            field: "LastName",
            headerName: "Last Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.LastName ? params.data.LastName : '--'
            },
            hide: IsMobileDevice
        },
        {
            field: "MaskedPhoneNumber",
            headerName: "Phone Number",
            valueFormatter: (params) => {
                return UtilityService.maskPhoneNumberOnLength(params.data.MaskedPhoneNumber)
            },
            valueGetter: (params: ValueGetterParams) => {
                const raw =
                    params.data?.PhoneNumber ||
                    params.data?.MaskedPhoneNumber ||
                    "";
                return `${raw} ${UtilityService.maskPhoneNumberOnLength(raw)} ${raw.replace(/\D/g, "")}`;
            },
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime).toString()
            },

            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            suppressSizeToFit: true
        },
    ]

    const onGridReady = (params) => {
        SetGridApi(params.api);
        SetColumnApi(params.columnApi)
    }
    const searchContact = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const gridRefresh = () => {
        LoadUnSubcribedContacts(dispatch)
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadUnSubcribedContacts(dispatch,));

    useEffect(() => {
        setHeaderTitle(pageTitles.OPTOUT_LIST);
        setRefreshHandler(gridRefresh)

        return setHeaderTitle

    }, []);

    return (
        <>
            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className=''>
                <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                    <div className="py-2">
                        <PageHeaderComponent
                            GridTitle={""}
                            onSearch={searchContact}
                            Count={GetUnSubscribedContacts.length}
                            PlaceHolder={"Find ..."}
                        />
                    </div>
                    <GridComponent
                        ColumnDefs={UnsubscribedColoumnDefs}
                        RowData={GetUnSubscribedContacts}
                        OnGridReady={onGridReady}
                        IsPaginationEnabled={!IsMobileDevice}
                        EmptyLabel={"There are no unsubscribed contacts at!"}
                        LockVisible={true}
                    />
                </div>
            </PullToRefresh>
        </>
    );
};

export default OptOutPolicy;
